import { FunctionComponent, lazy } from 'react'

const PersonalDetailsContainer = lazy(
  () => import('./PersonalDetailsContainer')
)

const PersonalDetailsLazyContainer: FunctionComponent = () => (
  <PersonalDetailsContainer />
)

export default PersonalDetailsLazyContainer
